(function($){
    if($('.single-product').length > 0){
        $(document).ready(function(){
            console.log('prod')
            $('.single-product img').each(function(){
                $(this).removeAttr('srcset');
            })
        })
    }
})(jQuery)